import { _t } from "../utils/Translator";

export enum EnrichmentInfoType {
  None = "none",
  CompanyCreated = "company_created",
  CompanyUpdated = "company_updated",
  NoData = "no_data",
  Other = "other",
  ConnectionError = "connection_error",
  EnrichContactWithNoEmail = "enrich_contact_with_no_email",
  NotConnected_NoData = "missing_data",
  NotConnected_InternalError = "internal_error",
  CouldNotGetTranslations = "could_not_get_translations",
  OdooCustomError = "odoo_custom_error"
}
class EnrichmentInfo {
  type: EnrichmentInfoType;
  info: string;
  errorMessage: string;

  constructor(type?: EnrichmentInfoType, info?: string, errorMessage?: string) {
    this.type = type || EnrichmentInfoType.None;
    this.info = info;
    this.errorMessage = errorMessage;
  }

  getTypicalMessage = () => {
    switch (this.type) {
      case EnrichmentInfoType.None:
        return "";
      case EnrichmentInfoType.CompanyCreated:
        return _t("Company created");
      case EnrichmentInfoType.CompanyUpdated:
        return _t("Company updated");
      case EnrichmentInfoType.NoData:
      case EnrichmentInfoType.NotConnected_NoData:
        return _t("No data found for this email address.");
      case EnrichmentInfoType.Other:
        return this.errorMessage ?? "";
      case EnrichmentInfoType.NotConnected_InternalError:
        return _t("Could not autocomplete the company. Internal error. Try again later...");
      case EnrichmentInfoType.ConnectionError:
        return _t("Could not connect to your database. Please try again.");
      case EnrichmentInfoType.EnrichContactWithNoEmail:
        return _t("This contact has no email address, no company could be enriched.");
      case EnrichmentInfoType.CouldNotGetTranslations:
        return _t("An error has occurred when trying to fetch translations.");
      case EnrichmentInfoType.OdooCustomError:
        return this.info;
      default:
        return "";
    }
  };

  static fromJSON(o: Object): EnrichmentInfo {
    return Object.assign(new EnrichmentInfo(), o);
  }
}

export default EnrichmentInfo;
